module.exports = __webpack_public_path__ + "img/tools2.6354d848.svg";